import { render, staticRenderFns } from "./PendingApprovalsTable.vue?vue&type=template&id=42fc4506&scoped=true&"
import script from "./PendingApprovalsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./PendingApprovalsTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PendingApprovalsTable.vue?vue&type=style&index=0&id=42fc4506&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fc4506",
  null
  
)

export default component.exports